import { useMutation } from "@tanstack/react-query";

import { getPracticeFilteredFieldIds } from "services";

import { GET_PRACTICE_FILTERED_FIELD_IDS } from "consts";

export const useGetPracticeFilteredFieldIds = () =>
  useMutation({
    mutationKey: [GET_PRACTICE_FILTERED_FIELD_IDS],
    mutationFn: getPracticeFilteredFieldIds,
  });
